import { baseCRUDAPI } from './base';

export default class Notify extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'Notify');
  }

  async register({
    email,
    firstName,
    lastName,
    phone,
    companyName,
    zip,
    interestedInFordProSolutions,
    notifyOfNews,
    notifyOfNewEvents,
  }) {
    return this.axiosObject.put(
      this.apiBaseName,
      {
        email,
        firstName,
        lastName,
        phone,
        companyName,
        zip,
        interestedInFordProSolutions,
        notifyOfNews,
        notifyOfNewEvents,
      },
    );
  }
}
